import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import { get, getOr } from "lodash/fp";
import { RedirectButton } from "../../Components/Form";
import { FontBold } from "../../Components/Auth/Layout";
import useHeaderComponentsMutation from "../../Hooks/useHeaderComponentsMutation";
import Loader from "../../Components/Loader";
import Search from "../../Components/Search/Index";
import { EVENT_TITLE } from "../../Constants/AppConstants";
import { FETCH_STUDENTS } from "../../GraphQL/Queries";
import useCurrentUser from "../../Hooks/userCurrentUser";
import useUserSearch from "../../Hooks/useUserSearch";
import {
  sortSelectStyle,
  filterAndSortUsers,
  formatJoinedAt,
} from "../../Hooks/eventUsersUtils";
import userDefaultImage from "../../Images/icons/userIcon.png";
import UserList from "../../Components/UserList/Index";
import RIGHT_ARROW from "../../Images/icons/right-color-arrow.png";

const Students = () => {
  const { currentUser } = useCurrentUser(true);
  const searchList = useUserSearch();
  const { id } = useParams();
  const [searchValue, setSearchValue] = useState("");
  const [sortOrder, setSortOrder] = useState("latest");
  const [fetchStudents, { data: studentsData, loading: studentsLoading }] =
    useLazyQuery(FETCH_STUDENTS);
  const students = getOr([], "eventStudents", studentsData);
  const filteredStudents = filterAndSortUsers(
    students,
    searchValue,
    sortOrder,
    searchList,
  );

  useEffect(() => {
    if (currentUser) {
      fetchStudents({
        variables: {
          eventId: id,
        },
      });
    }
  }, [currentUser, fetchStudents, id]);

  const searchStudent = (e) => {
    setSearchValue(e.target.value);
  };

  const onSortChange = (e) => {
    setSortOrder(e.target.value);
  };

  useHeaderComponentsMutation({
    title: "STUDENTS",
    backLink: `/event-manage/${id}`,
    components: [
      { key: EVENT_TITLE, value: get("[0]fetchEvent.title", students) },
    ],
  });

  return (
    <>
      <div className="mt-4" />
      <div className="row">
        <div className="col-md-6 col-12">
          <RedirectButton
            backgroundcolor="#F4AB37"
            fontColor="#FFF"
            border="none"
            addNewText="INVITE USER"
            addNewLink={`/event-manage/${id}/invite-existing-user/student`}
          />
        </div>
        <div className="col-md-6 col-12">
          <RedirectButton
            backgroundcolor="#FFF"
            fontColor="rgba(244, 171, 55, 1)"
            border="2px solid #f3AA44"
            addNewText="INVITE NEW USER"
            addNewLink={`/event-manage/${id}/invite-new-user/student`}
          />
        </div>
      </div>
      <Search placeholder="Search" onChange={searchStudent} />
      <div className="row mt-3">
        <div className="col-auto ml-auto px-4">
          <select
            id="student-sort-order"
            className="form-control"
            style={sortSelectStyle}
            value={sortOrder}
            onChange={onSortChange}
          >
            <option value="latest">Latest Joined</option>
            <option value="earliest">Earliest Joined</option>
          </select>
        </div>
      </div>
      <div className="row">
        <div className="col-12 mx-auto px-4">
          <FontBold>
            <p className="mt-4">
              Students(
              {filteredStudents.length})
            </p>
          </FontBold>
        </div>
      </div>
      {studentsLoading ? (
        <Loader />
      ) : (
        filteredStudents.map((eventUser) => (
          <>
            <div key={eventUser.id}>
              <UserList
                user={get("fetchUser", eventUser)}
                imageAttached={userDefaultImage}
                arrowIcon={RIGHT_ARROW}
                redirectLink={`/event-manage/${id}/event-user-profile/${get("id", get("fetchUser", eventUser))}`}
                joinedAt={formatJoinedAt(get("createdAt", eventUser))}
              />
            </div>
          </>
        ))
      )}
    </>
  );
};
export default Students;
